import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Field, FieldArray, FormikConsumer } from 'formik';
import FormControl from '../base/FormControl';
import { AppContext } from '../../../context/AppContext';

class RepeatTextField extends Component {
  static contextType = AppContext;

  render() {
    const controlClasses = ['form-item', 'form-item-textfield', 'form-item-textfield-repeat'];

    return (
      <FormikConsumer>
        {({ errors, touched, values }) => (
          <FormControl label={this.props.label}
            required={this.props.required}
            className={classNames(controlClasses)}
            name={this.props.name}>
            <FieldArray
              name={this.props.name}
              render={arrayHelper => {
                const rows = values[this.props.name] || [];

                return <Fragment>
                  <div className="repeat-rows">
                    {rows.map((row, index) => {
                      return <div className="repeat-row" key={index}>
                        <Field name={`${this.props.name}.${index}`} className={classNames('form-text', 'usa-input')} />
                        {index > 0 && <button type="button" className="usa-button usa-button--secondary">
                          <span className="glyphicon glyphicon-remove" onClick={() => arrayHelper.remove(index)}>Delete</span>
                        </button>}
                      </div>
                    })}
                  </div>
                  <button
                    type="button"
                    className="usa-button usa-button-primary"
                    onClick={() => arrayHelper.push('')}
                    disabled={rows.length >= this.props.limit}>
                    {this.props.buttonLabel}
                  </button>
                </Fragment>
              }}>
            </FieldArray>
          </FormControl >
        )}
      </FormikConsumer>
    );
  }
}

RepeatTextField.defaultProps = {
  limit: 3,
  className: [],
  validations: [],
  rows: [{ value: '' }]
};

RepeatTextField.propTypes = {
  limit: PropTypes.number,
  className: PropTypes.array,
  validations: PropTypes.array,
  rows: PropTypes.array
};

export default RepeatTextField;
